import { FC } from 'react';

import UsersDropdown from 'components/shared/UsersDropdown';
import { StepItem } from 'models';

interface VehicleCardUserDropDownProps {
  currentStep: StepItem | undefined;
  inventoryId: string | undefined;
}

export const VehicleCardUserDropDown: FC<VehicleCardUserDropDownProps> = ({
  currentStep,
  inventoryId,
}) => {
  if (!currentStep || !inventoryId) {
    return null;
  }

  return (
    <UsersDropdown
      inventoryId={inventoryId}
      currentStep={currentStep}
      loaderType="srpGradient"
    />
  );
};
